import React from 'react';
import { createRoot } from 'react-dom/client'; // Use createRoot from react-dom/client
import './index.css';
import App from './App';
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_SENTRY_ENABLE === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}
const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root not found');
}
